import { memo } from 'react'
import './styles.css'

const Card = memo(function Card({ children, className = '', ...props }) {
  return (
    <div className={`card ${className}`} {...props}>
      {children}
    </div>
  )
})

export default Card
